import { render } from "./SeccionBuscador.vue?vue&type=template&id=2fe65f5e&scoped=true"
import script from "./SeccionBuscador.vue?vue&type=script&lang=js"
export * from "./SeccionBuscador.vue?vue&type=script&lang=js"

import "./SeccionBuscador.vue?vue&type=style&index=0&id=2fe65f5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fe65f5e"]])

export default __exports__